// extracted by mini-css-extract-plugin
export default {"inheritIndicator":"inheritIndicator__inheritIndicator__EzOyk","align-end":"inheritIndicator__align-end__tcLNo","resetButton":"inheritIndicator__resetButton__wVKJl"};